/* eslint-disable
 */
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { LabelsView } from 'app/scripts/views/label/LabelsView';

import { PopOver } from 'app/scripts/views/lib/pop-over';
import { View } from 'app/scripts/views/internal/view';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';

class CardLabelSelectView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'labels';
  }

  el() {
    this.labelsView = this.subview(LabelsView, this.model, {
      board: this.model.getBoard(),
      selectLabel: this.toggleLabel.bind(this),
      renderOn: [
        { source: this.model.labelList, events: 'add remove reset change' },
        { source: this.model, events: 'change:labels, change:idLabels' },
      ],
      popOverMethod: 'pushView',
      searchInit: this.options.searchInit,
    });

    return this.labelsView.render().el;
  }

  toggleLabel(idLabel, fromSuggestion) {
    const taskName = 'edit-card/idLabels';
    const source = this.options.source || 'cardLabelsListInlineDialog';
    const traceId = Analytics.startTask({ taskName, source });
    this.model.toggleLabel(
      this.modelCache.get('Label', idLabel),
      null,
      tracingCallback({ taskName, source, traceId }),
    );
    if (this.options.hideOnSelect) {
      PopOver.popView();
    }
  }
}

CardLabelSelectView.initClass();
export { CardLabelSelectView };
